import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=f533c294&scoped=true"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"
import style0 from "./Survey.vue?vue&type=style&index=0&id=f533c294&prod&lang=scss"
import style1 from "./Survey.vue?vue&type=style&index=1&id=f533c294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f533c294",
  null
  
)

export default component.exports